var path = 'areas/projects/actions/docker_run/Octopus.DockerRun_summary.html';
var html = "<p> Deploy and Run a Docker Container <strong>{{ properties[\"Octopus.Action.Package.PackageId\"] }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ properties[\"Octopus.Action.Package.FeedId\"] }}</em> <span ng-show=isSingleStep>on machines in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/Octopus.DockerRun_summary.html
// module id = 7083183555301452
// module chunks = 1